



import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyCZ0SNHB1f_ub8u94ZorqAtV7LDwwlxjOQ",
  authDomain: "optica-billing-system-794ab.firebaseapp.com",
  projectId: "optica-billing-system-794ab",
  storageBucket: "optica-billing-system-794ab.firebasestorage.app",
  messagingSenderId: "190074590913",
  appId: "1:190074590913:web:e3b6671ac647ea15b5a640"
};
  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export























